import { render, staticRenderFns } from "./CoefficientForDilapidationEditModal.vue?vue&type=template&id=53ca0924&scoped=true&"
import script from "./CoefficientForDilapidationEditModal.vue?vue&type=script&lang=js&"
export * from "./CoefficientForDilapidationEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ca0924",
  null
  
)

export default component.exports